/// *** System import ***///
import { Injectable, Inject } from '@angular/core';
import { Events, ToastController } from 'ionic-angular';
import { Http, Headers, URLSearchParams, RequestOptions } from '@angular/http';
import { Storage } from '@ionic/storage';
import * as CryptoJS from 'crypto-js';
import 'rxjs/add/operator/map';
import { deepCopy } from 'ionic-angular/util/util';
import { RESOURCE_CACHE_PROVIDER } from '@angular/platform-browser-dynamic';
/// *** Custom import ***///
import { Globals } from '../../../app/globals';
import { EnvVariables } from '../../../app/environment-variables/environment-variables.token';
import { SessionProvider } from '../../../providers/session';
import { MarketSessionHubProvider } from '../../../providers/serverHubs/marketSession';

@Injectable()
export class Market_SessionStore {
  public params: any;
  private paramsKey: string;
  private defaultParams: any;
  private isPersistParams: boolean;
  public isServerPush = false;
  /// *** Data
  private sessionStore: any;
  public activeSession: any = {};
  constructor(
    // *** System
    private events: Events,
    private storage: Storage,
    private http: Http,
    private toastCtrl: ToastController,
    // *** Custom
    private globals: Globals,
    @Inject(EnvVariables) private envVariables,
    private session: SessionProvider,
    private marketSessionHubProvider: MarketSessionHubProvider) {
  }

  /// *** Configurer les paramètres
  public configParams(defaultParams: any, isPersistParams: boolean) {
    this.paramsKey = '_Market_SessionStore.local';
    this.params = defaultParams;
    this.defaultParams = defaultParams;
    this.isPersistParams = isPersistParams;
  }

  /// *** Récupérer les paramètres de la page
  public loadParams() {
    if (this.isPersistParams) {
      return this.storage.get(this.paramsKey).then(
        (data) => {
          if (data) {
            var paramsStr: string = CryptoJS.AES.decrypt(data.toString(), this.globals.CRYPTO_KEY).toString(CryptoJS.enc.Utf8);
            this.params = JSON.parse(paramsStr);
          }
          else {
            this.params = deepCopy(this.defaultParams);
            this.persistParams();
          }
        },
        (error) => {
          this.params = deepCopy(this.defaultParams);
          this.globals.showStorageError(this.toastCtrl, error);
        });
    }
    else {
      return new Promise<any>((resolve, reject) => { resolve() });
    }
  }

  /// *** Persister les paramètres de la page
  public persistParams() {
    if (this.isPersistParams) {
      var dataCrypt: string = CryptoJS.AES.encrypt(JSON.stringify(this.params), this.globals.CRYPTO_KEY).toString();
      return this.storage.set(this.paramsKey, dataCrypt).then(
        (succeed) => { },
        (error) => {
           this.globals.showStorageError(this.toastCtrl, error);
        });
    }
  }

  /// *** Charger le portfeuille du compte
  public load(isRefresh: boolean = false) {
    return new Promise((resolve, reject) => {
      if (isRefresh)
        this.reset();
      let session = null;
      let requestHeaders = new Headers();
      requestHeaders.append('Content-Type', 'application/json');
      let requestParams = new URLSearchParams();
      let options = new RequestOptions({ headers: requestHeaders, params: requestParams });
      this.http.get(this.envVariables.marketSessionApiEndpoint, options).map(res => res.json()).subscribe(
        (data) => {
          session = data;
          // Top trades
          requestParams = new URLSearchParams();
          requestParams.append('Top', this.params.topTrades.toString());
          options = new RequestOptions({ headers: requestHeaders, params: requestParams });
          this.http.get(this.envVariables.marketSessionTradesApiEndpoint, options).map(res => res.json()).subscribe(
            (data) => {
              session.topTrades = data;
              // Instruments
              requestParams = new URLSearchParams();
              requestParams.append('UserID', this.session.data.userID);
              requestParams.append('Groups', this.params.groups);
              requestParams.append('ShowFavorites', this.params.showFavorites ? 'true' : 'false');
              options = new RequestOptions({ headers: requestHeaders, params: requestParams });
              this.http.get(this.envVariables.marketInstrumentsApiEndpoint, options).map(res => res.json()).subscribe(
                (data) => {
                  session.instruments = data;
                  // Finalize
                  this.sessionStore = deepCopy(session);
                  this.activeSession = deepCopy(session);
                  this.sort();
                  this._eventsSub();
                  resolve();
                },
                (error) => {
                  this.globals.showCommunicationError(this.toastCtrl, error);
                  reject();
                });
            },
            (error) => {
              this.globals.showCommunicationError(this.toastCtrl, error);
              reject();
            });
        },
        (error) => {
          this.globals.showCommunicationError(this.toastCtrl, error);
          reject();
        });
    });
  }

  // *** Recherche dans la liste des instruments
  public search(ev) {
    this.activeSession.instruments = deepCopy(this.sessionStore.instruments);
    if (ev) {
      var filter: string = ev.target.value;
      if (filter && filter.trim() != '') {
        this.activeSession.instruments = this.activeSession.instruments.filter((item) => {
          let title = item.Symbol + ' ' + item.Name;
          let filters = filter.split(' ');
          for (let _filter of filters) {
            if (!(title.toLowerCase().indexOf(_filter.toLowerCase()) > -1))
              return false;
          }
          return true;
        });
      }
    }
    this.sort();
  }

  // *** Trier les instruments
  public sort() {
    // Sort By Name
    if ((this.params.sortField == 'name') && !this.params.isDescSort) {
      this.activeSession.instruments = this.activeSession.instruments.sort(function (item1, item2) {
        if (item1.Symbol < item2.Symbol)
          return -1;
        else if (item1.Symbol > item2.Symbol)
          return 1;
        else
          return 0;
      });
    }
    if ((this.params.sortField == 'name') && this.params.isDescSort) {
      this.activeSession.instruments = this.activeSession.instruments.sort(function (item1, item2) {
        if (item1.Symbol < item2.Symbol)
          return 1;
        else if (item1.Symbol > item2.Symbol)
          return -1;
        else
          return 0;
      });
    }
    // Sort By Variation
    if ((this.params.sortField == 'variation') && !this.params.isDescSort) {
      this.activeSession.instruments = this.activeSession.instruments.sort(function (item1, item2) {
        if (item1.LastPriceVariationSide == 'Blank')
          return -1;
        else if (item2.LastPriceVariationSide == 'Blank')
          return 1;
        else if (item1.LastPriceVariation < item2.LastPriceVariation)
          return -1;
        else if (item1.LastPriceVariation > item2.LastPriceVariation)
          return 1;
        else
          return 0;
      });
    }
    if ((this.params.sortField == 'variation') && this.params.isDescSort) {
      this.activeSession.instruments = this.activeSession.instruments.sort(function (item1, item2) {
        if (item1.LastPriceVariationSide == 'Blank')
          return 1;
        else if (item2.LastPriceVariationSide == 'Blank')
          return -1;
        else if (item1.LastPriceVariation < item2.LastPriceVariation)
          return 1;
        else if (item1.LastPriceVariation > item2.LastPriceVariation)
          return -1;
        else
          return 0;
      });
    }
    // Sort By Volume
    if ((this.params.sortField == 'volume') && !this.params.isDescSort) {
      this.activeSession.instruments = this.activeSession.instruments.sort(function (item1, item2) {
        if (item1.Volume < item2.Volume)
          return -1;
        else if (item1.Volume > item2.Volume)
          return 1;
        else
          return 0;
      });
    }
    if ((this.params.sortField == 'volume') && this.params.isDescSort) {
      this.activeSession.instruments = this.activeSession.instruments.sort(function (item1, item2) {
        if (item1.Volume < item2.Volume)
          return 1;
        else if (item1.Volume > item2.Volume)
          return -1;
        else
          return 0;
      });
    }
  }

  // *** Remise à zéro des informations du portefeuille
  public reset() {
    this.activeSession = {};
    this._eventsUnsub();
  }

  // *** S'inscrire aux évènements liés au portefeuille
  private _eventsSub() {
    try {
      this.marketSessionHubProvider.subscribe(this.session.data.userID);
      // On 'updateSessionStatus'
      this.events.subscribe('MarketSessionHubProvider.updateSessionStatus', (sessionDate: any, stateColor: any, state: any) => {
        try {
          this.isServerPush = true;
          // Active
          this.activeSession.SessionDate = Date.parse(sessionDate);
          this.activeSession.IsOpened = stateColor == 'green';
          this.activeSession.State = state;
          setTimeout(() => {
            this.isServerPush = false;
          }, 300);
          // Store
          this.sessionStore.SessionDate = Date.parse(sessionDate);
          this.sessionStore.IsOpened = stateColor == 'green';
          this.sessionStore.State = state;
        }
        catch (error) {
          //this.globals.showUnknownError(this.toastCtrl, error);
          this.isServerPush = false;
        }
      });
      // On 'updateSessionTrade'
      this.events.subscribe('MarketSessionHubProvider.updateSessionTrade', (volume: any, numberOfTransactions: any) => {
        try {
          this.isServerPush = true;
          // Active
          this.activeSession.Volume = volume;
          this.activeSession.NumberOfTransactions = numberOfTransactions;
          setTimeout(() => {
            this.isServerPush = false;
          }, 300);
          // Store
          this.sessionStore.Volume = volume;
          this.sessionStore.NumberOfTransactions = numberOfTransactions;
        }
        catch (error) {
          //this.globals.showUnknownError(this.toastCtrl, error);
          this.isServerPush = false;
        }
      });
      // On 'updateIndexSummary'
      this.events.subscribe('MarketSessionHubProvider.updateIndexSummary', (indexData: any) => {
        try {
          if (indexData.ISINCode == 'TN0009050014') {
            this.isServerPush = true;
            // Active
            this.activeSession.IndexLastLevel = indexData.LastLevel;
            this.activeSession.IndexLastLevelVariation = indexData.LastLevelVariation;
            this.activeSession.IndexLastLevelVariationSide = indexData.LastLevelVariationSide;
            setTimeout(() => {
              this.isServerPush = false;
            }, 300);
            // Store
            this.sessionStore.IndexLastLevel = indexData.LastLevel;
            this.sessionStore.IndexLastLevelVariation = indexData.LastLevelVariation;
            this.sessionStore.IndexLastLevelVariationSide = indexData.LastLevelVariationSide;
          }
        }
        catch (error) {
          //this.globals.showUnknownError(this.toastCtrl, error);
          this.isServerPush = false;
        }
      });
      // On 'updateStaticThresholds'
      this.events.subscribe('MarketSessionHubProvider.updateStaticThresholds', (instrumentData: any) => {
        try {
          // Active
          let activeInstrument = this.activeSession.instruments.find(item => item.ISINCode == instrumentData.ISINCode);
          if (activeInstrument) {
            activeInstrument.isServerPush = true;
            activeInstrument.LowerThreshold = instrumentData.LowerThreshold;
            activeInstrument.UpperThreshold = instrumentData.UpperThreshold;
            setTimeout(() => {
              activeInstrument.isServerPush = false;
            }, 300);
          }
          // Store
          let instrumentStore = this.sessionStore.instruments.find(item => item.ISINCode == instrumentData.ISINCode);
          if (instrumentStore) {
            instrumentStore.LowerThreshold = instrumentData.LowerThreshold;
            instrumentStore.UpperThreshold = instrumentData.UpperThreshold;
          }
        }
        catch (error) {
          //this.globals.showUnknownError(this.toastCtrl, error);
          this.isServerPush = false;
        }
      });
      // On 'updateTrade'
      this.events.subscribe('MarketSessionHubProvider.updateTrade', (instrumentData: any) => {
        try {
          // *** Instrument
          // Active
          let activeInstrument = this.activeSession.instruments.find(item => item.ISINCode == instrumentData.ISINCode);
          if (activeInstrument) {
            activeInstrument.isServerPush = true;
            activeInstrument.LastPrice = instrumentData.LastPrice;
            activeInstrument.LastPriceVariation = instrumentData.LastPriceVariation;
            activeInstrument.LastPriceVariationSide = instrumentData.LastPriceVariationSide;
            activeInstrument.LowestPrice = instrumentData.LowestPrice;
            activeInstrument.HighestPrice = instrumentData.HighestPrice;
            activeInstrument.Volume = instrumentData.Volume;
            activeInstrument.TotalQuantity = instrumentData.TotalQuantity;
            setTimeout(() => {
              activeInstrument.isServerPush = false;
            }, 300);
            if ((this.params.sortField == 'variation') || (this.params.sortField == 'volume'))
              this.sort();
          }
          // Store
          let instrumentStore = this.sessionStore.instruments.find(item => item.ISINCode == instrumentData.ISINCode);
          if (instrumentStore) {
            instrumentStore.LastPrice = instrumentData.LastPrice;
            instrumentStore.LastPriceVariation = instrumentData.LastPriceVariation;
            instrumentStore.LastPriceVariationSide = instrumentData.LastPriceVariationSide;
            instrumentStore.LowestPrice = instrumentData.LowestPrice;
            instrumentStore.HighestPrice = instrumentData.HighestPrice;
            instrumentStore.Volume = instrumentData.Volume;
            instrumentStore.TotalQuantity = instrumentData.TotalQuantity;
          }
          // *** Ticker
          // Active
          this.isServerPush = true;
          this.activeSession.topTrades.splice(0, 0, {
            ISINCode: instrumentData.ISINCode,
            Symbol: instrumentData.Symbol,
            TradeTime: instrumentData.LastTradeTime,
            Quantity: instrumentData.LastTradeQuantity,
            Price: instrumentData.LastPrice,
            PriceVariation: instrumentData.LastPriceVariation,
            PriceVariationSide: instrumentData.LastPriceVariationSide
          });
          this.activeSession.topTrades = this.activeSession.topTrades.slice(0, this.params.topTrades);
          // Store
          this.sessionStore.topTrades.splice(0, 0, {
            ISINCode: instrumentData.ISINCode,
            Symbol: instrumentData.Symbol,
            TradeTime: instrumentData.LastTradeTime,
            Quantity: instrumentData.LastTradeQuantity,
            Price: instrumentData.LastPrice,
            PriceVariation: instrumentData.LastPriceVariation,
            PriceVariationSide: instrumentData.LastPriceVariationSide
          });
          this.sessionStore.topTrades = this.sessionStore.topTrades.slice(0, this.params.topTrades);
        }
        catch (error) {
          //this.globals.showUnknownError(this.toastCtrl, error);
          this.isServerPush = false;
        }
      });
      // On 'updateInstrumentState'
      this.events.subscribe('MarketSessionHubProvider.updateInstrumentState', (instrumentData: any) => {
        try {
          // Active
          let activeInstrument = this.activeSession.instruments.find(item => item.ISINCode == instrumentData.ISINCode);
          if (activeInstrument) {
            activeInstrument.isServerPush = true;
            activeInstrument.State = instrumentData.State;
            activeInstrument.StateTime = instrumentData.StateTime;
            setTimeout(() => {
              activeInstrument.isServerPush = false;
            }, 300);
            if ((this.params.sortField == 'variation') || (this.params.sortField == 'volume'))
              this.sort();
          }
          // Store
          let instrumentStore = this.sessionStore.instruments.find(item => item.ISINCode == instrumentData.ISINCode);
          if (instrumentStore) {
            instrumentStore.State = instrumentData.State;
            instrumentStore.StateTime = instrumentData.StateTime;
          }
        }
        catch (error) {
          //this.globals.showUnknownError(this.toastCtrl, error);
          this.isServerPush = false;
        }
      });
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  // *** S'inscrire aux évènements liés au portefeuille
  private _eventsUnsub() {
    try {
      this.events.unsubscribe('MarketSessionHubProvider.updateSessionStatus');
      this.events.unsubscribe('MarketSessionHubProvider.updateSessionTrade');
      this.events.unsubscribe('MarketSessionHubProvider.updateIndexSummary');
      this.events.unsubscribe('MarketSessionHubProvider.updateStaticThresholds');
      this.events.unsubscribe('MarketSessionHubProvider.updateTrade');
      this.events.unsubscribe('MarketSessionHubProvider.updateInstrumentState');
      this.events.publish('MarketSessionHubProvider.abord');
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/market/session/session.store.ts